import { createTRPCContext } from "@trpc/tanstack-react-query";
import type { inferRouterOutputs, inferRouterInputs } from "@trpc/server";
import type { RentalsMerchantPortalRouter } from "@src/backend/src/rentals/functions/merchantsPortal";

// Create the TRPC React context
export const { TRPCProvider, useTRPC } =
  createTRPCContext<RentalsMerchantPortalRouter>();

export type RentalsMerchantPortalRouterOutputs =
  inferRouterOutputs<RentalsMerchantPortalRouter>;
export type RentalsMerchantPortalRouterInputs =
  inferRouterInputs<RentalsMerchantPortalRouter>;
